import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { DropdownMenu } from '../../ui/DropdownMenu';

import { usePostSortOrder } from '../../../_hooks/usePostSortOrder';
import type { SortTriggerComponentProps } from './sortTrigger.types';

export const SortOrderDropdown: FC<SortTriggerComponentProps> = ({ label, className, buttonProps, buttonContent }) => {
  const { t } = useTranslation();
  const { options, currentOption, setSort } = usePostSortOrder();

  return (
    <DropdownMenu
      className={className}
      value={currentOption.value}
      onChange={setSort}
      options={options}
      menuLabel={t('community.sort.sort_by')}
      buttonAriaLabel={t('community.sort.aria_label', { name: label, current: currentOption.label })}
      buttonProps={buttonProps}
      trigger={
        buttonContent ?? (
          <>
            <span className="text-xl font-semibold leading-6 tracking-[-0.4px] text-black">{label}</span>
            <ChevronDownIcon className="size-4 text-black/40" strokeWidth={2} aria-hidden="true" />
          </>
        )
      }
    />
  );
};
